import { render, staticRenderFns } from "./WarningBox.vue?vue&type=template&id=3b528a2a"
import script from "./WarningBox.vue?vue&type=script&lang=js"
export * from "./WarningBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b528a2a')) {
      api.createRecord('3b528a2a', component.options)
    } else {
      api.reload('3b528a2a', component.options)
    }
    module.hot.accept("./WarningBox.vue?vue&type=template&id=3b528a2a", function () {
      api.rerender('3b528a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/WarningBox.vue"
export default component.exports